
import { defineComponent, computed, ref, watch, watchEffect } from 'vue'
import { useStore } from 'vuex'
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
import BN from 'bignumber.js'
import { IToken } from '@/types'

export default defineComponent({
  name: 'TokenInput',
  components: {
    Menu,
    MenuButton,
    MenuItems,
    MenuItem
  },
  props: {
    title: { type: String, required: true },
    disabled: { type: Boolean },
    defaultTokenIdx: Number,
    AmountValue: Number,
    OutAmount: {
      type: Number,
      default: 0
    }
  },
  setup(props, { emit }) {
    const store = useStore()

    const tokens = computed(() => store.getters['swap/tokens']).value
    const amount = ref(0)
    // @ts-ignore
    const selectedToken = ref({ ...tokens[props.defaultTokenIdx], amount: 0 })

    const tokenForSearch = ref('')
    const filteredTokens = computed(() => {
      return tokens.filter(
        (el) =>
          el.name.toLowerCase().includes(tokenForSearch.value.toLowerCase()) ||
          el.symbol.toLowerCase().includes(tokenForSearch.value.toLowerCase())
      )
    })
    const balances = computed(() =>
      store.getters['swap/balances'](selectedToken)
    )
    const needApprove = computed(() => balances.value.allowance === 0)
    const insufficientBalance = computed(
      () => Number(amount.value) > balances.value.balance
    )

    function selectToken(token: IToken): void {
      selectedToken.value = token
    }

    watch(needApprove, () => {
      emit('hanldeApprove', needApprove)
    })

    watch(insufficientBalance, () => {
      emit('insufficientBalance', insufficientBalance)
    })

    watchEffect(() => {
      const amountBN = new BN(Number(amount.value)).times(
        `1e${selectedToken.value.decimals}`
      )
      selectedToken.value.amount = amountBN
      emit('handleToken', selectedToken)
    })

    return {
      tokens,
      selectedToken,
      selectToken,
      amount,
      filteredTokens,
      tokenForSearch,
      balances,
      needApprove,
      insufficientBalance
    }
  }
})
